import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import Loader from "../utils/Loader";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";

const { Text } = Inputs;

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];

function AddServicioPadre({ history, match }) {
  const dispatch = useDispatch();

  const modelAddServicio = useSelector((state) => state.cargarServicio);

  const [nombre, setNombre] = useState(null);
  const [estado, setEstado] = useState("ACTIVO");
  const [localId, setLocalId] = useState(match.params.localId);

  useEffect(() => {
    const data = modelAddServicio?.data?.data;
    const error = modelAddServicio?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      history.goBack();
      dispatch(controller.duck.actions.clear());
    }
  }, [modelAddServicio]);

  function submit() {
    if (!nombre || !estado || !localId) {
      alert("Por favor complete todos los campos");
      return;
    }
    let data = {
      nombre,
      estado,
      localId,
    };
    dispatch(controller.cargarServicioThunk(data));
  }
  return (
    <Content
      title="Nueva subcategoría"
      browserTitle="Nueva subcategoría"
      show={false}
    >
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Nueva subcategoría"
            footer={
              <>
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.goBack();
                  }}
                />

                <Button
                  type="primary"
                  text={
                    <Loader
                      loaderColor="#ffffff"
                      isLoading={modelAddServicio.loading}
                    >
                      Guardar
                    </Loader>
                  }
                  pullRight={true}
                  disabled={modelAddServicio.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />

            <Text
              labelPosition="above"
              size="sm"
              label={
                <Etiqueta texto="Nombre de la subcategoría" obligatorio={true} />
              }
              value={nombre}
              placeholder="Ej.: Tratamientos faciales"
              onChange={(evt) => setNombre(evt.target.value)}
            />

            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={estadoOptions()}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AddServicioPadre;
